<template>
  <div class="static-liul">
    <div class="input-content">
      <ElementSelect
        ref="timesel1"
        :label="$t('allDomain.timeGranularity')"
        :options="timeSelectsOptions"
        @selectValue="(e) => (dateLidu = e)"
      />

      <ElementSelect
         ref="timesel2"
        :label="$t('allDomain.timeFrame')"
        innerStyle="margin-left: 24px;"
        :options="timeRangeSelectsOptions"
        @selectValue="(e) => (dateRange = e)"
      />

      <div class="query-btn" @click="searchClick">{{$t('allDomain.query')}}</div>
    </div>
    <!-- <div class="echart-liul">
      <EchartLine :dataAxis="dataAxis" :ydata="ydata" />
    </div> -->
    <v-chart :options="options"  autoresize theme="light"/>
  </div>
</template>

<script>
/* eslint-disable */
import EchartLine from "@/components/EchartLine.vue";
import { apiGetStatic } from "@/service/requestRes";

import ECharts from 'vue-echarts'
import 'echarts/lib/chart/line'

export default {
  props: {
    mytype: String,
    name: String,
    id: String,
  },
  components: {
    EchartLine,
    'v-chart': ECharts,
  },
  data() {
    return {
      dataAxis: [],
      ydata: {}, 
      dateLidu: "1h",
      dateRange: "24h",
      options: {}

    };
  },
  computed: {
    timeSelectsOptions() {
      return [
        {
          label: `1${this.$t('allDomain.minute')}`,
          value: "1m",
        },
        {
          label: `5${this.$t('allDomain.minute')}`,
          value: "5m",
        },
        {
          label: `1${this.$t('allDomain.hour')}`,
          value: "1h",
        },
        {
          label: `1${this.$t('allDomain.day')}`,
          value: "1d",
        },
      ];
    },
    timeRangeSelectsOptions() {
      return [
        {
          label: `30${this.$t('allDomain.minute')}`,
          value: "30m",
        },
        {
          label: `6${this.$t('allDomain.hour')}`,
          value: "6h",
        },
        {
          label:  `12${this.$t('allDomain.hour')}`,
          value: "12h",
        },
        {
          label:  `24${this.$t('allDomain.hour')}`,
          value: "24h",
        },
        {
          label:  `${this.$t('allDomain.last7days')}`,
          value: "7d",
        },
        {
          label: `${this.$t('allDomain.last30days')}`,
          value: "30d",
        },
      ];
    },
  },
  mounted() {
    this.$refs.timesel1.value = '1h';
    this.$refs.timesel2.value = '24h';
    if (this.id) {
      this.searchClick();
    }
  },
  watch: {
    id(val) {
      if (val){
        this.searchClick();
      }
    },
    '$i18n.locale': function () {
        this.searchClick();
    },
  },
  methods: {
    searchClick() {
      if (!this.dateLidu) {
        this.$message({
          message: `${this.$t('allDomain.flowtip1')}`,
          type: "error",
        });
        return;
      }
      if (!this.dateRange) {
        this.$message({
          message:  `${this.$t('allDomain.flowtip2')}`,
          type: "error",
        });

        return;
      }
      let para = {
        func: this.mytype,
        interval_time: this.dateLidu,
        interval_day: this.dateRange,
      }
      if (this.name == 'product') {
        para['pid'] = parseInt(this.id);
      } else if (this.name == 'subhost') {
        para["sub_host"] = this.id;
      } else {
        para[this.name] = this.id;
      }
      this.getStaticData(para);
    },
    loadData(mydata){
      let staticName = {
        'reqflow': this.$t('allDomain.reqflow'),
        'sendflow': this.$t('allDomain.sendflow'),
        '2xx': `2xx(${this.$t('allDomain.second')})`,
        '3xx': `3xx(${this.$t('allDomain.second')})`,
        '4xx': `4xx(${this.$t('allDomain.second')})`,
        '5xx': `5xx(${this.$t('allDomain.second')})`,
        'wafs': this.$t('allDomain.DefenseTimes'),
        'hits': this.$t('allDomain.RequestRitRatio'),
        'flows': this.$t('allDomain.TrafficHitRate'),
        'sourceflow': this.$t('allDomain.sourceflow'),
      };
      let rdata = mydata.length && mydata || [{time: new Date()}];
      let series = [];
      let keys = [];
      // if ( !mydata || mydata.length == 0) {
      //   this.$message({
      //     message: "无数据",
      //     type: "warn",
      //   });
      //   return;
      // }
      keys = rdata[0] && Object.keys(rdata[0]).filter(e => e !== 'time') || [];
      keys.forEach(item => {
        series.push({
          name: staticName[item],
          type: 'line',
          data: rdata.map(v => { 
            return item.endsWith('flow') ? Number((v[item]).toFixed(2)) : v[item]
          })
        })
      });
      // series = keys.forEach(item => {
      //   return {
      //     name: item,
      //     type: 'line',
      //     data: rdata.map(v => { 
      //       return item.endsWith('flow') ? Number((v[item]).toFixed(2)) : v[item]
      //     })
      //   }
      // });
      this.options = {
        title: {
            text: ''
        },
        tooltip: {
            trigger: 'axis'
        },
        legend: {
            data: keys.map(x=>staticName[x])
        },
        grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
        },
        // toolbox: {
        //     feature: {
        //         saveAsImage: {}
        //     }
        // },
        xAxis: {
            type: 'category',
            // boundaryGap: false,
            data: rdata.map(item => { return this.$moment(item.time).format('MM-DD HH:mm')})
        },
        yAxis: {
            type: 'value'
        },
        series: series

      }


    },
    getStaticData(data) {
      apiGetStatic(this.name, data).then((res) => {
        const { data, code, msg } = res || {};
        const newArr = [];
        const newX = [];
        if (code === 1) {
            this.loadData(JSON.parse(data));
            // data && (typeof data === Array) && data.forEach(item => {
            //     const { time, wafs, hits, flows } = item || {};
            //     if (this.mytype === 'hits') {
            //         newX.push(hits);
            //     } else if (this.mytype === 'flows') {
            //         newX.push(flows);
            //     } else if (this.mytype === 'wafs') {
            //         newX.push(wafs);
            //     }
            //     newArr.push(time);
            // });

            this.ydata = newArr;
        } else {
          this.$message({
            message: msg,
            type: "error",
          });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.static-liul {
  min-height: 500px;
  .echart-liul {
    height: 300px;
  }
  .input-content {
    display: flex;
    align-items: flex-end;
    margin-bottom: 15px;
  }
  .query-btn {
    width: 100px;
    height: 44px;
    background: #336dff;
    border-radius: 4px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: PingFangSC-Semibold;
    font-size: 14px;
    color: #ffffff;
    margin: 0 auto;
    cursor: pointer;
    margin-left: 30px;
    margin-bottom: 10px;
  }
  .echarts {
  width: 60%;
  height: 300px;
}  
}
</style>
